import {QuickbetXState, QuickbetXActionTypes, QuickbetXAction} from "../../types/QuickbetX/quickbetXTypes";

const initialState: QuickbetXState = {
    quickbetXData: [],
    quickbetXloading: false,
    quickbetXerror: null,
};

export const quickbetXReducer = (state = initialState, action: QuickbetXAction): QuickbetXState => {
    switch (action.type) {
        case QuickbetXActionTypes.FETCH_QUICKBET_X_DATA:
            return { ...state, quickbetXloading: true, quickbetXerror: null, quickbetXData: [] };
        case QuickbetXActionTypes.FETCH_QUICKBET_X_DATA_SUCCESS:
            return { ...state, quickbetXloading: false, quickbetXerror: null, quickbetXData: action.payload };
        case QuickbetXActionTypes.FETCH_QUICKBET_X_DATA_ERROR:
            return { ...state, quickbetXloading: false, quickbetXerror: action.payload, quickbetXData: [] };
        default:
            return state;
    }
};
